module.exports = __webpack_public_path__ + "media/images/icons/outlined/arrow-right-11d5d7800af4fe112a0222f80141cf64.svg";